import "../../LayerType";
import "../../Format";
import "./Base";
import "./OL3/Tile";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");

/**
 * @class
 * @extends GIS.Map.Layer.Base
 */
GIS.Map.Layer.Tile = Class(GIS.Map.Layer.Base, /** @lends GIS.Map.Layer.Tile.prototype */ {
    vendors: {
        "ol3": GIS.Map.Layer.OL3.Tile
    },
    // options
    url: null,
    format: GIS.Format.PNG,
    tileFormat: GIS.Format.extension(GIS.Format.PNG),
    tileSize: [256, 256],
    tilePixelRatio: 1,
    layerName: null,
    /** @type {string[]} Additional url tokens */
    urlParams: ["layerName", "tileFormat"],
    /**
     * @inheritDoc
     */
    initialize()
    {
        this.ParentCall();

        this.layer.on("click", this.onLayerClick, this);
    },
    /** @inheritDoc */
    optionsNames()
    {
        return this.ParentCall().concat(["format", "tileSize", "tilePixelRatio", "tileFormat", "layerName",
            "url", "urlParams"]);
    },
    /**
     * @param options
     */
    prepareOptions(options)
    {
        options = this.Parent(options);

        if (options.format != null) {
            options.tileFormat = GIS.Format.extension(options.format);
        }

        if (options.tileSize != null && !_.isArray(options.tileSize)) {
            options.tileSize = [_.parseInt(options.tileSize)];
        }

        return options;
    },
    /**
     * @param {{pixel: number[], coordinate: number[]}} e
     * @fires GIS.Map.Layer.Tile#click
     * @protected
     */
    onLayerClick(e)
    {
        /**
         * @event GIS.Map.Layer.Tile#click
         * @type {{pixel: number[], coordinate: number[]}}
         */
        this.emit("click", e);
    },
    /**
     * @returns {number}
     */
    getType()
    {
        return GIS.LayerType.Raster;
    }
});
